import * as Application from "expo-application";
import Constants from "expo-constants";
import { Platform } from "react-native";

export function getAppVersionLabel(): string {
    if (Platform.OS === "web") {
        const version = Constants.expoConfig?.version ?? "?";
        const build = Constants.expoConfig?.extra?.buildNumber ?? "?";
        return `${version}-${build}`;
    }
    const version =
        Application.nativeApplicationVersion ??
        Constants.expoConfig?.version ??
        "?";
    const build =
        Application.nativeBuildVersion ??
        (Platform.OS === "ios"
            ? Constants.platform?.ios?.buildNumber
            : String(Constants.expoConfig?.android?.versionCode ?? "")) ??
        "?";
    return `${version}-${build}`;
}

/** Store version without the build number. Web has no native binary to compare. */
export function getNativeAppVersion(): string | null {
    if (Platform.OS === "web") {
        return null;
    }
    return (
        Application.nativeApplicationVersion ??
        Constants.expoConfig?.version ??
        null
    );
}
